import * as actionTypes from '../actionsTypes';
import axios from '../../../http-config';
import swal from 'sweetalert';
import { CodeSharp, ReportSharp } from '@material-ui/icons';
import moment from 'moment';

export const fetchPropertyListingSuccess = (response) => {
    return {
        type: actionTypes.FETCH_PROPERTYLISTING_SUCCESS,
        propertyListing:response.data.properties,
        propertyTypeList: response.data.propertyTypeList,
        totalCount : response.totalCount ,
        success:true
    }
}

export const fetchOperatorDaySuccess = (response) => {
    return {
        type: actionTypes.FETCH_OPERATORDAY_SUCCESS,
        operatorDay:response.data.ulbs,
          
    }
}
export const fetchPropertyTypeListingSuccess = (response) => {
    return {
        type: actionTypes.FETCH_PROPERTYTYPELISTING_SUCCESS,
        ListPropertyTypes: response.data.propertyTypes

    }
}
export const fetchOperatorListingSuccess = (response) => {
    return {
        type: actionTypes.FETCH_OPERATORLISTING_SUCCESS,
        operatorListing:response.data.operators,
          
    }
}
export const fetchSchedulePropertyZoneSucces =(response)=>{
    return {
        type : actionTypes.FETCH_SCHEDULEPROPERTYZONE_SUCCESS,
        scheduleProperty : response.data.zones
    }
}
export const fetchSchedulePropertyWardSucces =(response)=>{
    return {
        type : actionTypes.FETCH_SCHEDULEPROPERTYWARD_SUCCESS,
        scheduleProperty : response.data.wards
    }
}

export const fetchPropertyListingFail = (error) => {
    return {
        type: actionTypes.FETCH_PROPERTYLISTING_FAIL,
        error:error,
        success:true
    }
}

export const fetchOperatorListingFail = (error) => {
    return {
        type: actionTypes.FETCH_OPERATORLISTING_FAIL,
        error:error
    }
}


export const fetchPropertyListingStart = () => {
    return {
        type: actionTypes.FETCH_PROPERTYLISTING_START,
        success:false
    }
}
export const fetchOperatorListingStart = () => {
    return {
        type: actionTypes.FETCH_OPERATORLISTING_START
    }
}




export const fetchSummaryStart = () => {
    return {
        type: actionTypes.FETCH_SUMMARY_START,
        loading:false
    }
}

export const fetchSummarySuccess =(response)=>{
    return {
        type : actionTypes.FETCH_SUMMARY_SUCCESS,
        propertySummary : response.data,
        totalCount:response.totalCount,
        loading:true
    }
}

export const fetchSummaryFail = (error) => {
    return {
        type: actionTypes.FETCH_SUMMARY_FAIL,
        error:error,
        loading:false
    }
}

export const fetchStatusStart = () => {
    return {
        type: actionTypes.FETCH_STATUS_START
    }
}

export const fetchStatusSuccess =(response)=>{
    return {
        type : actionTypes.FETCH_STATUS_SUCCESS,
        status : response
    }
}

export const fetchStatusFail = (error) => {
    return {
        type: actionTypes.FETCH_STATUS_FAIL,
        error:error
    }
}

export const fetchHistoryStart = () => {
    return {
        type: actionTypes.FETCH_HISTORY_START,
        loading: false
    }
}

export const fetchPropertyListingLoadsSuccess= (response)=>{
    return {
        type:actionTypes.FETCH_PROPERTYLISTINGLOAD_SUCCESS,
        propertyListingLoad:response.data,
        totalCountLoads : response.totalCount ,
        successLoad:true
    }
}
export const fetchPropertyListingLoadsStart =()=>{
    return {
        type: actionTypes.FETCH_PROPERTYLISTINGLOAD_START,
        successLoad: false
    }
}
export const fetchPropertyListingLoadsFail =(err)=>{
    return {
        type: actionTypes.FETCH_PROPERTYLISTINGLOAD_FAIL,
        error:err,
        successLoad: true
    }
}
export const fetchHistorySuccess = (response) => {
    return {
        type: actionTypes.FETCH_HISTORY_SUCCESS,
        HistoryProperty:response.data,
        loading: true,
        totalCountHistorty : response.totalCount ,
          
    }
}
export const fetchHistoryFail = (error) => {
    return {
        type: actionTypes.FETCH_HISTORY_FAIL,
        error:error,
        loading:true
    }
}

export const fetchCitizenSuccess = (response) => {
    return {
        type: actionTypes.FETCH_CITIZEN_PROPERTY_SUCCESS,
        CitizenListing:response.data.data,
          
    }
}


export const fetchPropertyListing = (payload,url,type) => {
    // console.log(payload,"pppppppppppp")
    let api = ''
    // if(!!payload.zoneId && payload.zoneId !== '-1'){
    //     api =!payload.wardId ? `/property/?zoneId=${payload.zoneId}&page=${payload.page}&limit=${payload.limit}`:`/property/?wardId=${payload.wardId}&page=${payload.page}&limit=${payload.limit}`
    // }
    // else if(!!payload.searchQuery &&payload.searchQuery.length> 0 ){
    //  api= `/property/?name=${payload.searchQuery}&limit=${payload.limit}&page=${payload.page}`
    // }
    // else{
        if(type == 'schedule'){
            const search= payload.searchByFields == "propertyTyp"?`&propertyType=${payload.searchQuery}`:payload.searchByFields=="propertyName"? `&name=${payload.searchQuery}`: payload.searchByFields=="request"? `&requestId=${payload.searchQuery}`: ""
            api = url? url+`&sortColumnName=${payload.sortName}&sortType=${payload.sortValue}&propertyTypeId=${payload.propertyTypeId}&status=${payload.status}${search}` : `/property?sortColumnName=${payload.sortName}&sortType=${payload.sortValue}&propertyTypeId=${payload.propertyTypeId}`
        }else if(type == 'bulk'){
            api = '/property?limit=10&page=1' 
        }
        else{
            const search1= payload.searchByFields === "name"? `&name=${payload.searchQuery}`:payload.searchByFields == "created"? `&createdAt=${payload.searchDate}`: payload.searchByFields == "updated"?`&updatedAt=${payload.searchDate}`:""
            api = `/property?sortColumnName=${payload.sortName}&sortType=${payload.sortValue}&propertyTypeId=${payload.propertyTypeId}${search1}`
        // }
    }
   
    let token = payload.token;
    return dispatch => {
        dispatch(fetchPropertyListingStart());
        axios({
            method : 'get',
            url : api,
            headers :  {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            const fetchedpropertyListingResponse = response.data
            dispatch(fetchPropertyListingSuccess(fetchedpropertyListingResponse));
        })
        .catch((err) => {
            dispatch(fetchPropertyListingFail(err))
        })
    }
}


export const fetchOperatorListing = (payload,url,type) => {
    let api = '/operator/?list=true';
    let token = payload.token;
    return dispatch => {
        dispatch(fetchOperatorListingStart());
        axios({
            method : 'get',
            url : api,
            headers :  {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            const fetchedoperatorListingResponse = response.data
            dispatch(fetchOperatorListingSuccess(fetchedoperatorListingResponse));
        })
        .catch((err) => {
            dispatch(fetchOperatorListingFail(err))
        })
    }
}

export const addDayData = (payload,SubmitProp, props)=>{
    let token=payload.token;
    return (dispatch)=>{
        dispatch(fetchOperatorListingStart())

        let url = '/ulb/updateConfigDAy';
        axios.put(url, payload,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(function (response) {
            const fetchedDayData = response.data.success;
            fetchedDayData && swal({
                title: "Date Configured",
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
              })
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})  
        })
        .catch(error => {
            //dispatch(fetchUlbDataFail(error))           
        })
        
    }
}
export const fetchOperatorDay = (payload,url,type) => {
    let api = '/ulb/user_ulb';
    let token = payload.token;
    return dispatch => {
        dispatch(fetchOperatorListingStart());
        axios({
            method : 'get',
            url : api,
            headers :  {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            const fetchedoperatorDayResponse = response.data
            dispatch(fetchOperatorDaySuccess(fetchedoperatorDayResponse));
        })
        .catch((err) => {
            dispatch(fetchOperatorListingFail(err))
        })
    }
}



export const fetchPropertyBulkImport = (payload,formData) => {
    let token = payload.token
    return dispatch => {
        dispatch(fetchPropertyListingStart());
        const url = '/property/bulk'

        axios.post(url,formData,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(function (response) {
            if(response){
                const fetchedLoadsResponse = response.data.success;
                fetchedLoadsResponse && swal({
                    title: "Data Imported",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                  .then((bulk) => {
                    if (bulk) {
                    dispatch(fetchPropertyListing(payload,'','bulk'))
                    } 
                  });
            }
              
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})    
            dispatch(fetchPropertyListing(payload,'','bulk'))
        })
        .catch(error => {
            dispatch(fetchPropertyListingFail(error));
        })

    }
}

export const fetchAreaBulkImport = (payload,formData) => {
    let token = payload.token
    return dispatch => {
        dispatch(fetchPropertyListingStart());
        const url = '/area/bulk'

        axios.post(url,formData,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(function (response) {
            if(response){
                const fetchedLoadsResponse = response.data.success;
                fetchedLoadsResponse && swal({
                    title: "Data imported",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                  .then((bulk) => {
                    if (bulk) {
                    dispatch(fetchPropertyListing(payload))
                    } 
                  });
            }
              
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})   
            dispatch(fetchPropertyListing(payload))
        })
        .catch(error => {
            dispatch(fetchPropertyListingFail(error));
        })

    }
}

export const editPropertyData = (payload, t) => {
    const id=payload.get("id")
    let token=localStorage.getItem('token');
        return dispatch => {
            dispatch(fetchPropertyListingStart());
            const payload1 = {
                "Name"                : payload.buildingName,
                "OwnerName"           : payload.ownerName,
                "PropertyTypeId"        : payload.propertyType,
                "ContainmentTypeId"   : payload.containmentType,
                "Zone"              : payload.zone,
                "Ward"              : payload.wardNo,
                "isDisableProperty"   : payload.isDisableProperty,
                "Comments"              : payload.comment,
                "Emergency"              :payload.emergency,
                "Photo"               :payload.Photo,
                "PhoneNumber"        : payload.phoneNumber,
                "LastEmptiedDays" : payload.LastEmptiedDays,
                "LastEmptiedMonths" : payload.LastEmptiedMonths

            }
            const url = `property/${id}`   
            axios.put(url,payload,{headers:{
                "Authorization":`Bearer ${token}`
            }})
            .then(function (response) {
                const fetchedResponse = response.data.success;
                fetchedResponse && swal({
                    title: `${t("ulbEdit")}`,
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                dispatch(fetchPropertyListing({token: token, page:1, limit:10, sortName:'',sortValue:'',propertyTypeId:'' }))
                  
            }, (err) => {
                // console.log("ERRRRROR", err)
                swal({icon : "error" , title : err.response.data.error[0]["message"]})  
                dispatch(fetchPropertyListing({token: token, page:1, limit:10, sortName:'',sortValue:'',propertyTypeId:'' }))
            }).catch(err => {
                dispatch(fetchPropertyListingFail(err));
            })
        }
}

export const AddPropertySingle=(payload, t)=>{
    // console.log("Payload",payload)

    let token=localStorage.getItem('token');
    return dispatch => {
        dispatch(fetchPropertyListingStart());
        const payload1 = {
            "Name"                : payload.buildingName,
            "OwnerName"           : payload.ownerName,
            "PropertyTypeId"        : payload.propertyType,
            "ContainmentTypeId"   : payload.containmentType,
            "Zone"              : payload.zone,
            "Ward"            :payload.wardNo,
            // "Number"              : payload.wardNo,
            "isDisableProperty"   : payload.isDisableProperty,
            "Comments"              : payload.comment,
            "Emergency"              :payload.emergency,
            "Photo"               :payload.photo,
            "LastEmptied"         :payload.lastEmptied,
            "PhoneNumber"        : payload.phoneNumber,
            "LastEmptiedDays" : payload.LastEmptiedDays,
            "LastEmptiedMonths" : payload.LastEmptiedMonths

        }
        const url = `property/add`   
        axios.post(url,payload,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(function (response) {
            // console.log(response.data, "Response")
            const fetchedResponse = response.data.success;
            
            fetchedResponse && swal({
                title: `${t("disposalAdd")}`,
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
              })
            dispatch(fetchPropertyListing({token: token, sortName:'',sortValue:'',propertyTypeId:'' }))
              
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})  
            dispatch(fetchPropertyListing({token: payload.token, sortName:'',sortValue:'',propertyTypeId:'' }))
        }).catch(err => {
            dispatch(fetchPropertyListingFail(err));
        })
    }
}
export const deleteProperty = (payload, t)=>{
    return dispatch =>{
        const url = `/property/${payload.propertyId}`
        axios.delete(url,{ headers: {'Authorization': `Bearer ${payload.token}`}})
        .then(function (response) {
            const fetchedResponse = response.data.success;
            dispatch(fetchPropertyListing(payload,'','schedule'));
            fetchedResponse && swal({
                title: `${t("ulbDeleteErr5")}`,
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
              })
            //   props.history.push('/property-management')  
              
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})  
            dispatch(fetchPropertyListing(payload,'','schedule'));
        }).catch(err => {
            dispatch(fetchPropertyListingFail(err));
            dispatch(fetchPropertyListing(payload,'','schedule'));
        })
    }
   
}

export const scheduleProperty = (payload,props) => {
    let token = localStorage.getItem('token');
        return dispatch => {
            dispatch(fetchPropertyListingStart());
            const url = `schedule`   
            axios.post(url,payload,{headers:{
                "Authorization":`Bearer ${token}`
            }})
            .then(function (response) {
                const fetchedResponse = response.data.success;
                    dispatch(fetchPropertyListing({token:localStorage.getItem('token'),page:props.pageSchedule,limit:10, sortName: props.SORT.key, sortValue:props.SORT.value, propertyTypeId: payload.propertyTypeId,status:payload.status},`/property?`,'schedule'));
                fetchedResponse && swal({
                    title: `Property Scheduled`,
                    text: `Upcoming Schedule Date is : ${moment(payload.date).format('DD-MM-YYYY')}`,
                    icon: "success",
                    className: "swal-back-edit",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                  
            }, (err) => {
                swal({icon : "error" , title : err.response.data.error[0]["message"]})  
                dispatch(fetchPropertyListing({token:localStorage.getItem('token'),page:props.pageSchedule,limit:10, sortName: props.SORT.key, sortValue:props.SORT.value, propertyTypeId: payload.propertyTypeId,status:payload.status},`/property?`,'schedule'));
            }).catch(err => {
                dispatch(fetchPropertyListingFail(err));
            })
        }
}

export const schedulePropertyZone=()=>{
    let token = localStorage.getItem('token');
    return dispatch =>{
        dispatch(fetchPropertyListingStart());
        const url =`/zone/getZones`
        axios.get(url, {headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(response=>{
            const fetchedScheduleListingResponse = response.data
            dispatch(fetchSchedulePropertyZoneSucces(fetchedScheduleListingResponse));
        }).catch(err=>{
            dispatch(fetchPropertyListingFail(err));
        })
    }
}

export const schedulePropertyWard =( payload)=>{
    let token = localStorage.getItem('token');
    return dispatch =>{
        dispatch(fetchPropertyListingStart());
        const url =`/ward/zone?zoneId=${payload.zoneId}&forScheduleProperty=true&status=${payload.status}`
        axios.get(url, {headers:{
            "Authorization":`Bearer ${token}`
        }}).then(response=>{
            const fetchedScheduleListingWArdResponse = response.data
            dispatch(fetchSchedulePropertyWardSucces(fetchedScheduleListingWArdResponse));
        }).catch(err=>{
            dispatch(fetchPropertyListingFail(err));
        })
    }
}

export const filterZoneAndWard =(payload)=>{
    const wardIdAvli = payload.wardId
    let token = localStorage.getItem('token');
    return dispatch =>{
        dispatch(fetchPropertyListingStart());
        if(!!wardIdAvli && wardIdAvli.length>0){
            const url = `/property/?wardId=${payload.wardId}&page=${payload.page}&limit=${payload.limit}&forScheduleProperty=true&status=${payload.status}`
            axios.get(url, {headers:{
                "Authorization":`Bearer ${token}`
            }}).then(response=>{
                const fetchedSchedulePropertyListingResponse = response.data
                response && response.data && response.data.data &&
                response.data.data.properties && 
                response.data.data.properties.length == 0 && 
                swal("No Records Found !", {
                    icon: "warning",
                  });
                dispatch(fetchPropertyListingSuccess(fetchedSchedulePropertyListingResponse));
            }).catch(err=>{
                dispatch(fetchPropertyListingFail(err));
            })
        }else{
            const url = `/property/?zoneId=${payload.zoneId}&page=${payload.page}&limit=${payload.limit}` 
            axios.get(url, {headers:{
                "Authorization":`Bearer ${token}`
            }}).then(response=>{
                const fetchedSchedulePropertyListingResponse = response.data
                dispatch(fetchPropertyListingSuccess(fetchedSchedulePropertyListingResponse));
            }).catch(err=>{
                dispatch(fetchPropertyListingFail(err));
            })
        }
       
      
    }
}

export const searchProperty=(payload,Url,type)=>{
    return dispatch =>{
        dispatch(fetchPropertyListingStart());
        const url =type == 'schedule'?payload.searchByFields == "propertyTyp"? Url+`&propertyType=${payload.searchQuery}`:payload.searchByFields=="propertyName"? Url+`&name=${payload.searchQuery}`: payload.searchByFields=="request"?  Url+`&requestId=${payload.searchQuery}`: "": payload.searchByFields === "name"? `/property/?name=${payload.searchQuery}`:payload.searchByFields == "created"? `/property/?createdAt=${payload.searchDate}`: payload.searchByFields == "updated"?`/property/?updatedAt=${payload.searchDate}`:  payload.searchByFields == "selectName" ? `/property`:''
        axios.get(url,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }} ).then(response=>{
            response && response.data && response.data.data &&
            response.data.data.properties && 
            response.data.data.properties.length == 0 && 
            swal("No Records Found !", {
                icon: "warning",
              });
            dispatch(fetchPropertyListingSuccess(response.data));
        }).catch(err=>{
            dispatch(fetchPropertyListingFail(err));
        })
    }
}

export const fetchPropertyHisorty=(payload)=>{
    // const api = `lload_status?propertyId=4975&allData=true`
    // load_status?propertyId=196&allData=true&allData=true&status=
    return dispatch =>{
        dispatch(fetchSummaryStart());
        const url =`/load_status?propertyId=${payload.viewHistory}&allData=true&status=${payload.status}`
        axios.get(url,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }} ).then(response=>{
            dispatch(fetchSummarySuccess(response.data));
        }).catch(err=>{
            dispatch(fetchSummaryFail(err));
        })
    }
}

export const fetchStatus = (payload)=>{
    return dispatch =>{
        dispatch(fetchStatusStart());
        const url =`/schedule/get_total?fromDate=${payload.fromDate}&toDate=${payload.toDate}`
        axios.get(url,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }} ).then(response=>{
            dispatch(fetchStatusSuccess(response.data.data));
        }).catch(err=>{
            dispatch(fetchStatusFail(err));
        })
    }
}

export const exportSummary = (payload) => {
    return dispatch => {
        const url = `load_status?export=true&fromDate=${payload.fromDate}&toDate=${payload.toDate}`
        axios({
            method: 'get',
            url: url,
            headers: {'Authorization': `Bearer ${payload.token}`}
        })
        .then(function (response) {
            let link1=response.data.data[0].file_path
            
            window.downloadFile = function (link) {
                window.open(link, '_blank');
            }
            window.downloadFile(link1)
          
        }).catch(error => {
        })

    }
}

export const exportProperty = (payload) => {
    return dispatch => {
        const url = `property?export=true`
        axios({
            method: 'get',
            url: url,
            headers: {'Authorization': `Bearer ${payload.token}`}
        })
        .then(function (response) {
            let link1=response.data.data[0].file_path
            
            window.downloadFile = function (link) {
                window.open(link, '_blank');
            }
            window.downloadFile(link1)
          
        }).catch(error => {
        })

    }
}
export const addFreqSchedule=(payload,props)=>{
    const payload1 = {
        propUpdateFreqdays:payload.propUpdateFreqdays
    }
    return dispatch =>{
        dispatch(fetchPropertyListingStart());
        const url = `/property/edit_auto_schedule_day/${payload.propertyId}`
        axios.put(url,payload1,{ headers: {'Authorization': `Bearer ${payload.token}`}})
        .then(function (response) {
            const fetchedResponse = response.data.success;
            dispatch(fetchPropertyListing({token:payload.token,sortName: payload.sortName, sortValue:payload.sortValue, propertyTypeId: payload.propertyTypeId},'','schedule'));
          if(payload.selecedFreq === "custom" ||payload.selecedFreq == '' ){
            fetchedResponse&& swal({
                title: "Scheduled Frequency Updated",
                icon: "success",
                text: `Upcoming Schedule Frequency ${moment(new Date()).add(payload.propUpdateFreqdays, 'days').format('DD-MM-YYYY')}.`,
                className: "swal-back-edit",
                buttons: {
                    confirm: 'Ok'
                }
              })
          }
          
             if(payload.selecedFreq === "alternate"){
                fetchedResponse && swal({
                    title: "Scheduled Frequency Updated",
                    text: `Upcoming Schedule Frequency ${moment(new Date()).add(payload.propUpdateFreqdays, 'days').format('DD-MM-YYYY')}.`,
                    icon: "success",
                    className: "swal-back-edit",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
            }
             if(payload.selecedFreq === "daily"){
                fetchedResponse && swal({
                    title: "Scheduled Frequency Updated",
                    
                    text: `Upcoming Schedule Frequency ${moment(new Date()).add(payload.propUpdateFreqdays, 'days').format('DD-MM-YYYY')}.`,
                    icon: "success",
                    className: "swal-back-edit",
                    buttons: {
                        confirm: 'Ok'
                    }
                    
                  })
                  
            }
          
            //   props.history.push('/schedule-property/allData')  
              
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})  
            dispatch(fetchPropertyListing({token:payload.token,page:1,limit:10,sortName: payload.sortName, sortValue:payload.sortValue, propertyTypeId: payload.propertyTypeId},'','schedule'));
        }).catch(err => {
            dispatch(fetchPropertyListingFail(err));
        })
    }
}

export const EditScheduleProperty = (payload, propsData)=>{
    let token = localStorage.getItem('token');
    return dispatch => {
        dispatch(fetchPropertyListingStart());
        const url = `schedule`   
        axios.put(url,payload,{headers:{
            "Authorization":`Bearer ${token}`
        }})
        .then(function (response) {
            const fetchedResponse = response.data.success;
            if(propsData.urlPropertyType === "all"){
                dispatch(fetchPropertyListing({token:localStorage.getItem('token'),
                sortName: propsData.SORT.key, 
                sortValue:propsData.SORT.value, propertyTypeId:payload.propertyTypeId, status:payload.status}
                ,`/property?`,'schedule'));
            }else{
                dispatch(fetchPropertyListing({token:localStorage.getItem('token'),
                sortName: propsData.SORT.key, 
                sortValue:propsData.SORT.value, propertyTypeId:payload.propertyTypeId, status:payload.status}
                ,propsData.uRl,'schedule'));
            }
          
            fetchedResponse && swal({
                title: "Scheduled Property Edited",
                text: `Upcoming Schedule Date is : ${moment(payload.date).format('DD-MM-YYYY')}`,
                icon: "success",
                className: "swal-back-edit",
                buttons: {
                    confirm: 'Ok'
                }
              })
              
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})  
            dispatch(fetchPropertyListing({token:localStorage.getItem('token'),
             sortName: propsData.SORT.key, 
            sortValue:propsData.SORT.value, propertyTypeId:payload.propertyTypeId, status:payload.status}
            ,propsData.uRl,'schedule'));
        }).catch(err => {
            dispatch(fetchPropertyListingFail(err));
        })
    }
}

export const propertyType=()=>{
    let token = localStorage.getItem('token');
    return dispatch =>{
        dispatch(fetchPropertyListingStart());
        const url = `/property_type`
        axios.get(url,{headers:{
            "Authorization":`Bearer ${token}`
        }}) .then((response) => {
            const fetchedpropertyListingResponse = response.data
            dispatch(fetchPropertyTypeListingSuccess(fetchedpropertyListingResponse));
        })
        .catch((err) => {
            dispatch(fetchPropertyListingFail(err))
        })
    }
}

export const deleteSchedule = (payload, props)=>{
    return dispatch =>{
        const url = `/schedule/${payload.scheduleId}`
        axios.delete(url,{ headers: {'Authorization': `Bearer ${payload.token}`}})
        .then(function (response) {
            const fetchedResponse = response.data.success;
            dispatch(fetchPropertyListing(payload,'','schedule'));
            fetchedResponse && swal({
                title: "Scheduled Property Deleted",
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
              })
            //   props.history.push('/schedule-properties')  
              
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})  
            dispatch(fetchPropertyListing({token: payload.token, page:1, limit:10, sortName:'',sortValue:'',propertyTypeId:'' }))
        }).catch(err => {
            dispatch(fetchPropertyListingFail(err));
        })
    }
   
}

export const historyOfProperty = (payload)=>{
    let token = payload.token;
    return dispatch => {
        dispatch(fetchHistoryFail());
        axios({
            method : 'get',
            url : `load_status?name=${payload.searchQuery}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}&propertyTypeId=${payload.propertyTypeId}&status=${payload.status}`,
            headers :  {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            const fetchedpropertyListingResponse = response.data
            dispatch(fetchHistorySuccess(fetchedpropertyListingResponse));
        })
        .catch((err) => {
            dispatch(fetchHistoryStart(err))
        })
    }
}
export const exportHistory =(payload)=>{
    return dispatch => {
        const url = `load_status?export=true&limit=${payload.limit}&page=${payload.page}&name=${payload.searchQuery}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}&propertyTypeId=${payload.propertyTypeId}&status=${payload.status}`
        axios({
            method: 'get',
            url: url,
            headers: {'Authorization': `Bearer ${payload.token}`}
        })
        .then(function (response) {
            let link1=response.data.data[0].file_path
            
            window.downloadFile = function (link) {
                window.open(link, '_blank');
            }
            window.downloadFile(link1)
          
        }).catch(error => {
        })

    }
}

export const searchHistoryProperty=(payload)=>{
    return dispatch =>{
        dispatch(fetchHistoryStart());
        
        const url =`load_status?name=${payload.searchQuery}&limit=${payload.limit}&page=${payload.page}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}&propertyTypeId=${payload.propertyTypeId}&status=${payload.status}`
        axios.get(url,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }} ).then(response=>{
            response && response.data && response.data.data &&
            response.data.data.properties && 
            response.data.data.properties.length == 0 && 
            swal("No Records Found !", {
                icon: "warning",
              });
            dispatch(fetchHistorySuccess(response.data));
        }).catch(err=>{
            dispatch(fetchHistoryFail(err));
        })
    }
}


export const fetchStatusHistory = (payload)=>{
    return dispatch =>{
        dispatch(fetchStatusStart());
        const url =`load_status/historyCount?name=${payload.searchQuery}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}&propertyTypeId=${payload.propertyTypeId}&status=${payload.status}`
        axios.get(url,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }} ).then(response=>{
            dispatch(fetchStatusSuccess(response.data.data));
        }).catch(err=>{
            dispatch(fetchStatusFail(err));
        })
    }
}


export const isZoneRequired =(payload, props)=>{

    return (dispatch)=>{
        dispatch(fetchOperatorListingStart())

        let url =  `ulb/isZoneRequired`
        axios.put(url, payload,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }})
        .then(function (response) {
            const fetchedDayData = response.data.success;
            fetchedDayData && swal({
                title: "Zone Required Mode Updated",
                icon: "success",
                buttons: {
                    confirm: 'Ok'
                }
              })
              window.location.reload()
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})  
        })
        .catch(error => {
            //dispatch(fetchUlbDataFail(error))           
        })
        
    }
}

export const loadDataSummmary=(payload)=>{
    let token = payload.token;
    return dispatch => {
        dispatch(fetchPropertyListingLoadsStart());
        axios({
            method : 'get',
            url :!!payload.summaryhistoryData&&payload.summaryhistoryData != ''? `load_status?fromDate=${payload.fromDateSumm}&toDate=${payload.toDateSumm}&status=${payload.statusSumm}&hyperlink=true&sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}&propertyTypeId=${payload.propertyTypeId}`:`load_status?fromDate=${payload.fromDateSumm}&toDate=${payload.toDateSumm}&status=${payload.statusSumm}&sortColumnName=${payload.sortName}&sortColumnType=${payload.sortValue}&propertyTypeId=${payload.propertyTypeId}`,
            headers :  {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            const fetchedpropertyListingResponse = response.data
            dispatch(fetchPropertyListingLoadsSuccess(fetchedpropertyListingResponse));
        })
        .catch((err) => {
            dispatch(fetchPropertyListingLoadsFail(err))
        })
    }

}

// ulb/updateSummmaryReportsEmail
export const emailUpdate = (payload,props) => {
    return dispatch => {
        dispatch(fetchSummaryStart());
        let url = 'ulb/updateSummmaryReportsEmail';
        axios.put(url, payload,{headers:{
            "Authorization":`Bearer ${payload.token}`
        }})
        .then(response => {
            // dispatch(fetchUlbData(payload));
            const fetchedResponse = response.data.success;
            if(fetchedResponse ===true){
                fetchedResponse && swal({
                    title: "Email address configured successfully",
                    icon: "success",
                    buttons: {
                        confirm: 'Ok'
                    }
                  })
                  props.history.push('/schedule-property/allData')
            }
             
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})          
        })
        .catch(err => {
            dispatch(fetchSummaryFail(err));
        })
    }
}

export const citizenPropertyAdd=(payload, props)=>{
    return dispatch => {
        const url = `auth/add`   
        axios.post(url,payload,{headers:{
            "Authorization":`Bearer `
        }})
        .then(function (response) {
        //    dispatch(fetchCitizenSuccess(response))

           const fetchResponse = response.data.success
           console.log(response,"response");
           if(fetchResponse === true){
            swal({
                icon:"success",
                title:"Request submitted successfully",
                text:`Request Id:- ${!!response&&response.data&& response.data.data[0]["request_Id_prefix"]}`
               }).then((will)=>{
                if(will){
                    props.history.push("/")
                }
               })
           }
            
        }, (err) => {
            swal({icon : "error" , title : err.response.data.error[0]["message"]})  
        }).catch(err => {
            swal({icon : "error" , title : "Server issue!!"})  
            // dispatch(fetchPropertyListingFail(err));
        })
    }
}